import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  filterBySaving: false,
  selectedStatus: null,
  searchText: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  dataInicial: null,
  dataFinal: null,
  dataFaturamentoInicial: null,
  dataFaturamentoFinal: null,
  grupo: [],
  fornecedor: [],
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
